export const UPDATE_SHIPPING_STATUS = 'UPDATE_SHIPPING_STATUS';
export const UPDATE_SHIPPING_STATUS_SUCCESS = 'UPDATE_SHIPPING_STATUS_SUCCESS';
export const UPDATE_SHIPPING_STATUS_FAIL = 'UPDATE_SHIPPING_STATUS_FAIL';

export const GET_DRIVER_SCAN_RECORD = "GET_DRIVER_SCAN_RECORD";
export const GET_DRIVER_SCAN_RECORD_SUCCESS = "GET_DRIVER_SCAN_RECORD_SUCCESS";
export const GET_DRIVER_SCAN_RECORD_FAIL = "GET_DRIVER_SCAN_RECORD_FAIL";

export const UPDATE_SHIPPING_STATUS_SIMPLE = "UPDATE_SHIPPING_STATUS_SIMPLE"
export const UPDATE_SHIPPING_STATUS_SIMPLE_SUCCESS = "UPDATE_SHIPPING_STATUS_SIMPLE_SUCCESS"
export const UPDATE_SHIPPING_STATUS_SIMPLE_FAIL = "UPDATE_SHIPPING_STATUS_SIMPLE_FAIL"

export const GET_RETRY_POD = "GET_RETRY_POD"
export const GET_RETRY_POD_SUCCESS = "GET_RETRY_POD_SUCCESS"
export const GET_RETRY_POD_FAIL = "GET_RETRY_POD_FAIL"

export const SWITCH_RETRY = "SWITCH_RETRY"
export const SWITCH_RETRY_SUCCESS = "SWITCH_RETRY_SUCCESS"
export const SWITCH_RETRY_FAIL = "SWITCH_RETRY_FAIL"

export const GET_FAILED_REASON = "GET_FAILED_REASON"
export const GET_FAILED_REASON_SUCCESS = "GET_FAILED_REASON_SUCCESS"
export const GET_FAILED_REASON_FAIL = "GET_FAILED_REASON_FAIL"

export const GET_CUSTOMER_COMPLAIN_REASON = "GET_CUSTOMER_COMPLAIN_REASON"
export const GET_CUSTOMER_COMPLAIN_REASON_SUCCESS = "GET_CUSTOMER_COMPLAIN_REASON_SUCCESS"
export const GET_CUSTOMER_COMPLAIN_REASON_FAIL = "GET_CUSTOMER_COMPLAIN_REASON_FAIL"

export const GET_CUSTOMER_COMPLAIN = "GET_CUSTOMER_COMPLAIN"
export const GET_CUSTOMER_COMPLAIN_SUCCESS = "GET_CUSTOMER_COMPLAIN_SUCCESS"
export const GET_CUSTOMER_COMPLAIN_FAIL = "GET_CUSTOMER_COMPLAIN_FAIL"

export const CREATE_CUSTOMER_COMPLAIN = "CREATE_CUSTOMER_COMPLAIN"
export const CREATE_CUSTOMER_COMPLAIN_SUCCESS = "CREATE_CUSTOMER_COMPLAIN_SUCCESS"
export const CREATE_CUSTOMER_COMPLAIN_FAIL = "CREATE_CUSTOMER_COMPLAIN_FAIL"

export const UPDATE_SIGNATURE_REQUIRED = "UPDATE_SIGNATURE_REQUIRED"
export const UPDATE_SIGNATURE_REQUIRED_SUCCESS = "UPDATE_SIGNATURE_REQUIRED_SUCCESS"
export const UPDATE_SIGNATURE_REQUIRED_FAIL = "UPDATE_SIGNATURE_REQUIRED_FAIL"

export const UPDATE_FAILED_REASON = "UPDATE_FAILED_REASON"
export const UPDATE_FAILED_REASON_FAIL = "UPDATE_FAILED_REASON_FAIL"
export const UPDATE_FAILED_REASON_SUCCESS = "UPDATE_FAILED_REASON_SUCCESS"